import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowForward = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_forward" {...props} />
))

ArrowForward.displayName = 'ArrowForward'

export default ArrowForward
